import NewsLetterPopup from '../../../components/organisms/newsLetterPopup/NewLetterPopup';
import tastify from '@frontastic/catwalk/src/js/helper/tastify';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useLocalStorage } from 'react-use';

const NewsLetterPopupTastic = ({ data, context }) => {
  if (!data) return null;

  const locale = context?.locale === 'en_AU@AUD' ? 'AU' : 'NZ';
  if (!data[`show${locale}`]) return null;

  const { label, title, subTitle, image } = data;
  const [showModal, setShowModal] = useState(false);
  const [isNewsletterClosed, setIsNewsletterClosed] = useState(false);
  const [visitedValue, setVisitedValue, removeValue] = useLocalStorage(
    'isNewsletterVisited',
  );
  const currentTime = new Date().getTime();

  useEffect(() => {
    setShowModal(true);
    let timer;
    if (!visitedValue || visitedValue?.expiry < currentTime) {
      removeValue();
      timer = setTimeout(() => {
        setShowModal(true);
      }, 10000);
    }
    return () => clearTimeout(timer);
  }, []);

  const closedNewsLetterPopup = () => {
    setShowModal(false);
    setIsNewsletterClosed(false);
    setVisitedValue({
      value: 1,
      expiry: new Date().getTime() + 1000 * 60 * 60 * 24 * 7,
    });
  };

  return (
    !visitedValue?.value &&
    !isNewsletterClosed && (
      <NewsLetterPopup
        label={label}
        title={title}
        text={subTitle}
        image={image}
        showModal={showModal}
        onSet={() => {
          const mouseClickEvents = ['mousedown', 'click', 'mouseup'];

          const element =
            document.getElementById('openAccountPopup').children[3];

          mouseClickEvents.forEach((mouseEventType) =>
            element.dispatchEvent(
              new MouseEvent(mouseEventType, {
                view: window,
                bubbles: true,
                cancelable: true,
                buttons: 1,
              }),
            ),
          );
        }}
        startModalWidth={image?.media?.file ? 877 : 600}
        isMobilePaddings={true}
        typograghyPosition="start"
        isNewsletterClosed={isNewsletterClosed}
        onCloseModal={closedNewsLetterPopup}
      />
    )
  );
};

NewsLetterPopupTastic.propTypes = {
  data: PropTypes.object.isRequired,
};

export default tastify({ translate: true, connect: { context: true } })(NewsLetterPopupTastic);
